// extracted by mini-css-extract-plugin
export var restrictedWidthButton = "_nm-0";